export const COLOR = {
    WHITE: '#ffffff',
    RED: '#ef5141',
    GREY: '#8b8784',
    BLACK: '#232323',
};
